import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import ChatNotificationButton from 'externals/ChatNotificationButton';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { ButtonCustomProps, TRiskManagementProps } from 'open-search/types';
import React from 'react';

interface IActions {
  riskManagement: TRiskManagementProps;
  openTruckerProfileButtonProps: ButtonCustomProps;
  openSearchWidth: number;
  hasChatButton: boolean;
  searchedTrucker: ITruckerProfileProps;
}
const Actions = ({
  riskManagement,
  openTruckerProfileButtonProps,
  openSearchWidth,
  hasChatButton,
  searchedTrucker,
}: IActions) => (
  <FuelFlex defaultProps={{ alignItems: 'center', gap: 'km4' }}>
    {hasChatButton && (
      <ChatNotificationButton
        source="open-search"
        truckerUuid={searchedTrucker?.trucker?.uuid}
        truckerName={searchedTrucker?.trucker?.name}
        withBorder
        hasSendMessageTooltip
        buttonSize="medium"
      />
    )}
    {riskManagement.buttonRiskManagement.states.isVisible && (
      <FuelButton
        variant="secondary"
        data-testid="risk-management-button"
        onClick={riskManagement.buttonRiskManagement.events.onClick}
        fullWidth
      >
        {riskManagement.buttonRiskManagement.states.textContent}
      </FuelButton>
    )}
    <FuelButton
      variant="primary"
      data-testid="open-trucker-profile-button"
      onClick={openTruckerProfileButtonProps.events.onClick}
      trailingIcon={openSearchWidth >= 400 && !hasChatButton ? 'arrow-right' : ''}
    >
      {openSearchWidth >= 400
        ? openTruckerProfileButtonProps.states.textContent
        : openTruckerProfileButtonProps.states.textContentMobile}
    </FuelButton>
  </FuelFlex>
);

export default Actions;
